import $ from 'jquery';
import wishlist from 'modules/wishlist';
import initColorSwatches from './plpswatches';
import { renderPlpSocialProof } from '../../modules/social-proof';
import { trackPsykhePlpView } from "../../modules/psykhe";

export const SELECTORS = {
  sortBy : '#sortby',
  clearFilter: '.clear_filters',
  doneFilter: '#done_filters',
  filterClickable: '.plp-filter-clickable',
  catFilter : '#category',
  dateFilter : '#newarrivals',
  designerFilter: '#alldesigners',
  departmentFilter: '#department',
  filterItemSelect: '.filters__item-select',
  refineButton: '#refine-filters-button',
};

const FILTER_NAMES = ['designer', 'category', 'size', 'color', 'heel', 'price'];
const FILTERS_PARAM_NAME = 'filters';
const FILTERS_APPLIED_DELIMITER = "-";
const COLOR_FILTER = '#allcolors';
const SIZE_FILTER = '#allsizes';
const HEEL_FILTER = '#heel';
const PRICE_FILTER = '#allprices';
const CONDITION_FILTER = '#condition-select';
const CATEGORIES_FILTER = '#allcategories';
const FILTER_IDS = `${SELECTORS.designerFilter}, ${COLOR_FILTER}, ${SIZE_FILTER}, `
    + `${SELECTORS.catFilter}, ${CONDITION_FILTER}, ${HEEL_FILTER}, ${CATEGORIES_FILTER}, ${PRICE_FILTER}`;

$(function() {
   window.onpopstate = function() {
       updateContent(location.pathname + location.search);
   };

   if (!isWishlistPage() && !isPersonalShopPage()) {
       dynamicallyDisableFilters();
       updateDropdownNavUrlsOnLoad();
   }
});

export default function manageRefineMenu() {
    // left the department selector separate here to maintain existing behavior but changed to use common `const` value
    $(FILTER_IDS + `, ${SELECTORS.departmentFilter}`).on('change', function() {
        uncheckSelectAllOption(this);
        loadBrandsURL(this, null, true, true);
    });

    $(SELECTORS.clearFilter).click(function(event) {
        event.preventDefault();
        $(FILTER_IDS).prop('selectedIndex', 0).each(function() {
            if ($(this).attr("multiple")) {
                setLabel(this);
            }
        });
        const curDep = getQueryParamValues(window.location.href, 'd')[0];
        setFilterOptionSelectedByValue($('#department'), curDep);

        loadBrandsURL(this, null, true, true);
    });

    $(SELECTORS.sortBy).change(function(){
        loadBrandsURL(this, null, true);
    });

    $(SELECTORS.catFilter).change(function(){
        loadBrandsURL(this);
    });

    $(SELECTORS.dateFilter).change(function () {
        const safeUrl = prepareForSafeRemove($(this).find('input:checked').data('url'));
        const url = safeRemoveParam(safeUrl, 'fromSidePanel');
        location.href = safeConcat(url, 'fromSidePanel=true');
    });

    $(SELECTORS.filterClickable).click(function(e){
        e.preventDefault();
        loadBrandsURL(this);
    });

    $(SELECTORS.filterItemSelect).change(function(e) {
      setLabel(this);
    });

    $(SELECTORS.doneFilter).click(function() {
       $(SELECTORS.refineButton).click();
    });

    reloadBindJs();
}

function uncheckSelectAllOption(elem) {
    const $el = $(elem);
    const refineValue = $el.val();
    if(refineValue && refineValue.length > 1 && !refineValue[0]) {
        $el.find('.select_all').removeAttr('selected').prop("selected", false);
    }
}

function setLabel(elem) {
  const $elem = $(elem); // select
  const elParent = $elem[0].closest('.filters__item'); // label (parent)
  const selectedLabel = $(elParent).data('selected-label'); // label's data value
  const isDepartment = (selectedLabel == 'Department');
  const elValue = $elem.find(":selected").text().trim();
  const labelCopy = $(elParent).children('.filters__item-copy')[0]; // label span(1st child)
  const numSelectedOptions = Array.isArray($elem.val()) && $elem.val().filter(option => !!option).length; // selects values amount - might need
  if (numSelectedOptions) {
    $(labelCopy).text(`${selectedLabel} (${numSelectedOptions})`);
  } else if(isDepartment) {
    $(labelCopy).text(`${selectedLabel} (${elValue})`);
  } else {
    $(labelCopy).text(selectedLabel);
  }
}

function setFilterOptionSelectedByValue(filterElement, value) {
    if(value && filterElement.find('option[value="' + value + '"]').length > 0) {
        filterElement.val(value);
    }
}

function getSingleItemOption(element) {
    return element && element.length ? element.val() : '';
}

function getMultiItemOptions(element){
    if (element && element.length > 0) {
        if (window.rcProps.sidebarHref) {
            const checkedValues = [];
            element.find('input[type="checkbox"]:checked').each(function(){
                checkedValues.push(this.value);
            });
            return checkedValues;
        } else {
            // Remove empty values (i.e., the "All" value) if there are other values
            // Customer will have clear all filters or de-select filters to get back the "All" value
            let options = element.val();
            if (options && options.length > 1){
                var rtn = [];
                for (var i=0; i<options.length; i++){
                    if (options[i] != '')
                        rtn.push(options[i]);
                }
                options = rtn;
            }
            return options;
        }
    } else {
        return [''];
    }
}

function getQueryParamValues(url, param) {
    let result = [];
    if (url) {
        const paramsAndValues = url.slice(url.indexOf('?') + 1).split('&');
        for (let i = 0; i < paramsAndValues.length; i++) {
            if (paramsAndValues[i]) {
                const paramAndValue = paramsAndValues[i].split('=');
                if (2 == paramAndValue.length && (param == paramAndValue[0])) {
                    result.push(paramAndValue[1]);
                }
            }
        }
    }
    return result;
}

window.dynamicallyEnableDisableFilters = function (filterMenuList) {
    if (!filterMenuList)
        return -1;
    for (let j = 0; j < filterMenuList.length; j++) {
        const filterMenu = filterMenuList[j];
        if (!filterMenu || !filterMenu.idForHTML || !filterMenu.filterMenuList)
            continue;
        const filterId = filterMenu.idForHTML;
        let isSelected = false;
        for (let i = 0; i < filterMenu.filterMenuList.length; i++) {
            const filterObj = filterMenu.filterMenuList[i];
            if (filterObj) {
                let option = window.rcProps.sidebarHref
                    ? $(`#${filterId} input[value="${filterObj.value}"]`)
                    : $(`#${filterId} option[value="${filterObj.value}"]`);
                if (option.length) {
                    const propToCheck = window.rcProps.sidebarHref ? 'checked' : 'selected';
                    if (filterObj.disabled && option.prop(propToCheck)) {
                        option.prop(propToCheck, false);
                        option.trigger("change");
                        return;
                    } else {
                        option.prop("disabled", filterObj.disabled);
                        option.prop(propToCheck, filterObj.selected);
                        if (filterObj.selected == true) {
                            isSelected = true;
                        }
                    }
                }
            }
        }

        if (!isSelected) {
            let selectAllOption = $('#'+filterId+' .select_all');
            if (selectAllOption.length) {
                selectAllOption.prop('selected', true);
            }
        }
    }
}

window.reloadBindJs = function () {
    $('.js-pagination').click(function (e) {
        e.preventDefault();
        loadBrandsURL(this);
    });

    wishlist.checkWihlistTagId();
    wishlist.bindWishListEvent();
    initColorSwatches();
}

function dynamicallyDisableFilters() {
    let data = $.param({
        url: location.pathname + location.search,
        isMen: $('#isMen').length ? $('#isMen').val() : 'false'
    });

    $.ajax({
        url: window.rcProps.filteredPlpContentsUrl,
        data: data,
        dataType: 'json',
        type: 'POST',
        success: function (data) {
            if (data.filterMenuList) {
                for (let j = 0; j < data.filterMenuList.length; j++) {
                    const filterMenu = data.filterMenuList[j];
                    if (!filterMenu || !filterMenu.idForHTML || !filterMenu.filterMenuList) {
                        continue;
                    }
                    const filterId = filterMenu.idForHTML;
                    for (let i = 0; i < filterMenu.filterMenuList.length; i++) {
                        const filterObj = filterMenu.filterMenuList[i];
                        if (!filterObj) {
                            continue;
                        }
                        const option = $('#'+filterId+' option[value="'+filterObj.value+'"]');
                        if (option.length && filterObj.disabled && option.prop("selected")) {
                            option.prop("selected", false);
                            option.trigger("change");
                            return;
                        }
                    }
                }
            }
        }
    });
}

function ContentUpdate(pdpUrl) {
    const isWishList = isWishlistPage();
    const isPersonalShop = isPersonalShopPage();

    let canceled = false;
    this.go = function() {
        let data = {};
        let ajaxEndpoint;

        if (isWishList) {
            ajaxEndpoint = pdpUrl.replace(/^[^?]*/, '/fw/mobile/WishListContent.jsp');
        } else if (isPersonalShop) {
            ajaxEndpoint = pdpUrl.replace(/^[^?]*/, '/ajax' + window.location.pathname);
        } else {
            ajaxEndpoint = window.rcProps.filteredPlpContentsUrl;
            data = $.param({
                url: pdpUrl,
                isMen: $('#isMen').length ? $('#isMen').val() : 'false'
            });
        }

        $.ajax({
            url: ajaxEndpoint,
            data: data,
            dataType: isWishList ? 'text' : 'json',
            type: 'POST',
            success: function (data, status, xhr) {
                if (!canceled) {
                    if (isWishList) {
                        const $htmlData = $($.parseHTML(data));
                        const extraData = JSON.parse($htmlData.filter('#ajax-response-data').add($htmlData.find('#ajax-response-data')).text());
                        if($("html, body").hasClass("page-constrain")) {
                            $(SELECTORS.refineButton).click();
                        }
                        $('#productsList').html(data);
                        $('#plp-item-count').html(extraData.productCountStr);
                        $('.js-fixed-overlay').fixedOverlay();
                        $('.js-lazy-image').lazy();
                        dynamicallyEnableDisableFilters(extraData.filterMenuList);
                        reloadBindJs();
                    } else if (isPersonalShop) {
                        if($("html, body").hasClass("page-constrain")) {
                            $(SELECTORS.refineButton).click();
                        }
                        $('#plp-product-list').html(data.products);
                        $('#plp-item-count').html(data.productCountStr);
                        dynamicallyEnableDisableFilters(data.filterMenuList);
                        reloadBindJs();
                    } else {
                        $('#plp-product-list').html(data.plpMarkup);
                        $('#plp-pagination-wrapper-ajax').html(data.paginationMarkup);
                        $('#plp-item-count').html(data.productCountStr);
                        dynamicallyEnableDisableFilters(data.filterMenuList);
                        reloadBindJs();
                        renderPlpSocialProof($('.js-plp-container').toArray().map((el) => $(el).prop('id')));
                        trackPsykhePlpView();
                    }

                    $('#refine-filters-button.js-toggle-display').toggleDisplay();
                    $('#clear_filters').show();
                    $("html").animate({ scrollTop: 0 }, 'fast');
                    insertPageTrackForMobile(false, null, pdpUrl);
                }
            },
            error: function() {
                window.location.assign(pdpUrl);
            }
        });


        return this;
    };

    this.cancel = function() {
        canceled = true;
    };
}

let updateContent = (function() {
    let pending = null;

    return function(pdpUrl) {
        if (pending) {
            pending.cancel();
            pending = null;
        }
        pending = new ContentUpdate(pdpUrl).go();
        return pending;
    };
}());

function getUrlParams(currentUrl, featuredSort) {
    const departmentFromForm = window.rcProps.sidebarHref ? $('#department input:checked').val() : $('#department').val();
    return {
        path: currentUrl,
        sortBy: featuredSort ? featuredSort : ($('#sortby option:selected').length > 0 ? $('#sortby option:selected').val() : ['']),
        catFilter : $('#category').val(),
        department: departmentFromForm || getQueryParamValues(currentUrl, 'd')[0],
        designers: $('#alldesigners').length ? getMultiItemOptions($('#alldesigners')) : ($('#searchdesigner').length ? getSingleItemOption($('#searchdesigner')) : getQueryParamValues(window.location.href, 'designer')),
        sizes: getMultiItemOptions($('#allsizes')),
        colors: getMultiItemOptions($('#allcolors')),
        heels: getMultiItemOptions($('#heel')),
        prices: getMultiItemOptions($('#allprices')),
        conditions: getMultiItemOptions($('#condition-select')),
        category: getMultiItemOptions($(CATEGORIES_FILTER)),
        featuredCodes: getQueryParamValues(currentUrl, 'featuredCodes'),
        arrivalDate: $('#newarrivals').length > 0
            ? window.rcProps.sidebarHref
                ? $('#newarrivals input:checked').val()
                : $('#newarrivals').prop('value')
            : '',
        pageNum: parseInt($('#pageNum_param').val())
    };
}

function getUrlParamsFromUrl(currentUrl, urlParams = {}) {
    const base = window.location.origin;
    const url = new URL(currentUrl, base);
    const params = new URLSearchParams(url.search);
    const result = {
        path: urlParams.path,
        sortBy: urlParams.sortBy,
        catFilter: urlParams.catFilter,
        department: urlParams.department,
        designers: Object.assign([], urlParams.designers),
        sizes: Object.assign([], urlParams.sizes),
        colors: Object.assign([], urlParams.colors),
        prices: Object.assign([], urlParams.prices),
        heels: Object.assign([], urlParams.heels),
        conditions: Object.assign([], urlParams.conditions),
        category: Object.assign([], urlParams.category),
        featuredCodes: urlParams.featuredCodes,
        arrivalDate: urlParams.arrivalDate,
        pageNum: urlParams.pageNum,
    };

    // Helper: merge array field without duplicates
    const mergeArray = (arr, val) => {
        if (!arr.includes(val)) {
            arr.push(val);
        }

        // Filter empty values in-place
        arr.splice(0, arr.length, ...arr.filter(v => v != null && v.toString().trim() !== ''));
    }

    params.forEach((value, key) => {
        switch (key.toLowerCase()) {
            case 'designer':
                mergeArray(result.designers, value);
                break;
            case 'size':
                mergeArray(result.sizes, value);
                break;
            case 'color':
                mergeArray(result.colors, value);
                break;
            case 'price':
                mergeArray(result.prices, value);
                break;
            case 'heel':
                mergeArray(result.heels, value);
                break;
            case 'condition':
                mergeArray(result.conditions, value);
                break;
            default:
                // ignore everything else
                break;
        }
    });

    return result;
}

function isWishlistPage() {
    return window.location.href.indexOf("WishList.jsp") > -1;
}

function isPersonalShopPage() {
    return window.location.href.indexOf("PersonalShop.jsp") > -1;
}


function isSearchPage() {
    return window.location.href.indexOf('SearchResults.jsp') > -1;
}

function isNewPage() {
    return $('#newarrivals').length > 0;
}

function getCustomUrl() {
    return $('#department').find(":selected").data("href");
}

function loadBrandsURL(elem, featuredSort, resetToPageOne, appendParamsToDropdownNav) {
    if (elem === 'undefined')
        return;

    let currentUrl = window.location.href;
    if (elem.id === 'sortby') {
        currentUrl = removeURLParameter(currentUrl, 'featuredCodes');
    }
    const urlParams = getUrlParams(currentUrl, featuredSort);
    const isNew = isNewPage();
    const isWishList = isWishlistPage();
    const isPersonalShop = isPersonalShopPage();
    const selectFromCategory = $(elem).closest('div').prop('id') === 'plp_filter_dd';
    // category filters
    if (selectFromCategory) {
        urlParams.path = $(elem).data('caturl');
        resetFilters(urlParams);
    }

    let isPagination = false;
    // pagination
    if (elem.id === 'prev_btn') {
        urlParams.pageNum = urlParams.pageNum - 1;
        isPagination = true;
    }

    if (elem.id === 'next_btn') {
        urlParams.pageNum = urlParams.pageNum + 1;
        isPagination = true;
    }

    if ($(elem).hasClass("js-pagination")){
        urlParams.pageNum = $(elem).data("pageNum");
        isPagination = true;
    }
    if (resetToPageOne) {
        urlParams.pageNum = 1;
    }

    let newURL = '';
    const alreadyParams = urlParams && urlParams.path.indexOf("?") > -1;
    //var isPrettyURL = (urlParams.path.indexOf(".jsp") < 0);
    urlParams.path = removeFilterParams(urlParams);
    urlParams.path = safeRemoveParam(urlParams.path, 'arrivalDate');
    if (alreadyParams) {
        let amp = '&';
        if (urlParams.path.indexOf("?") === (urlParams.path.length - 1))
            amp = '';
        newURL = urlParams.path + amp + getFilterParams(urlParams);
    } else {
        newURL = urlParams.path + '?' + getFilterParams(urlParams);
    }

    // append arrival date for selected status
    if (isNew)
        newURL = newURL + "&arrivalDate=" + urlParams.arrivalDate;

    if (isPersonalShop) {
        newURL = newURL + "&personalshop=true";
    }

    const filtersObj = updateUrlForFiltersParam(newURL);
    if (!selectFromCategory && !isPagination && !isNew && !isWishList && !isPersonalShop && appendParamsToDropdownNav) {
        appendFilterParamsToDropdownNav(urlParams, filtersObj);
    }
    removeHash(filtersObj.url);
    updateContent(filtersObj.url);
}

function keepFilters() {
    return window.rcProps && window.rcProps.keepRefineFilter;
}

function appendFilterParamsToDropdownNav(urlParams, filtersObj){
    if (!keepFilters() || !filtersObj) {
        return;
    }
    $('.js-page-header__nav-list li.ui-list__item a').each(function(){
        if (!filtersObj.isAddedFilter) {
            $(this).attr('href', $(this).data('originalHref'));
            return;
        }

        const currentHref = $(this).attr('href');
        const urlParamsFromUrl = getUrlParamsFromUrl(currentHref, urlParams);
        const filtersObjFromUrl = updateUrlForFiltersParam(currentHref);
        const baseUrl = removeURLParameters(currentHref, FILTER_NAMES);
        let newUrl = replaceURLParameters(baseUrl, getFilterParams(urlParamsFromUrl));
        newUrl = clearQueryParameters(newUrl, {
            pageNum : true,
            filter: true,
            sortBy: true
        });

        $(this).attr('href', filtersObjFromUrl.filtersApplied ? replaceURLParameters(newUrl, 'filters=' + filtersObjFromUrl.filtersApplied) : clearQueryParameters(newUrl, {
            'filters': true
        }));
    });
}

function updateDropdownNavUrlsOnLoad() {
    if (!keepFilters()) {
        return;
    }
    if ($('#clear_filters').css('display') !== 'none' && !isNewPage() && !isSearchPage()) {
        const currentUrl = window.location.href;
        const urlParams = getUrlParams(currentUrl, null);
        const filtersObj = updateUrlForFiltersParam(currentUrl);
        appendFilterParamsToDropdownNav(urlParams, filtersObj);
    }
}

function updateUrlForFiltersParam(url) {
    let filtersApplied = '';
    const urlArray = url.split("?");
    if (urlArray.length > 1) {
        filtersApplied = getFiltersApplied(urlArray[1]);
    } else {
        return url;
    }
    const filtersNotApplied = {};
    url = removeURLParameter(url, FILTERS_PARAM_NAME);
    let isAddedFilter = false;
    $.each(FILTER_NAMES, function (index, value) {
        if (url.indexOf(value+'=') >= 0 || url.indexOf(value+'%5B%5D=') >= 0) {
            isAddedFilter = true;
            if (filtersApplied.indexOf(value) < 0) {
                filtersApplied = addFilterApplied(filtersApplied, value);
            }
        } else {
            filtersNotApplied[value] = true;
        }
    });

    for (let filterType in filtersNotApplied) {
        filtersApplied = removeFilterApplied(filtersApplied, filterType);
    }

    if (filtersApplied)
        url = replaceURLParameters(url, FILTERS_PARAM_NAME + '=' + filtersApplied);
    else
        url = clearQueryParameters(url, {filters: ''});
    return {
        url: url,
        isAddedFilter: isAddedFilter,
        filtersApplied: filtersApplied
    };
}

function removeURLParameters(url, parameterNameList) {
    if (url && parameterNameList.length > 0) {
        parameterNameList.forEach(function (parameterName) {
            url = removeURLParameter(url, parameterName);
            url = removeURLParameter(url, parameterName + "[]");
        });
    }
    return url;
}

function clearQueryParameters(url, params) {
    for (let p in params) {
        url = removeURLParameter(url, p);
        url = removeURLParameter(url, p + "[]");
    }
    return url;
}

function appendQuery(url, query) {
    if ("" == query) {
        return url;
    }
    query = $('<div/>').html(query).text();
    return url + ((url.indexOf("?") > -1) ? "&" : "?") + query;
}

function addFilterApplied(filtersAppliedDelimited, filterToAdd) {
    let result;

    if (filtersAppliedDelimited) {
        result = filtersAppliedDelimited.indexOf(filterToAdd) >= 0 ?
          filtersAppliedDelimited :
          filtersAppliedDelimited + FILTERS_APPLIED_DELIMITER + filterToAdd;
    } else {
        result = filterToAdd;
    }

    return result;
}

function removeFilterApplied(filtersAppliedDelimited, filterToRemove){
    // /-{1}filter|filter{1}-|filter/g
    return filtersAppliedDelimited.replaceAll(new RegExp('-{1}' + filterToRemove + '|' + filterToRemove + '-{1}|' + filterToRemove, 'g'), '');
}

function getFiltersApplied(fullQueryString){
    if (fullQueryString) {
        let qs = fullQueryString.split('&');
        if (qs) {
            for (let i = 0; i < qs.length; ++i) {
                const p = qs[i].split('=', 2);
                if (p[0] === 'filters') {
                    return p.length === 1 ? '' :  decodeURIComponent(p[1].replace(/\+/g, " ")).replace(/^=/, "");
                }
            }
        }
    }
    return '';
}

function removeHash(url) {
    let scrollV, scrollH, loc = window.location;
    if ("pushState" in history) {
        const urlWithoutHash = url ? url.replace('#', '') : loc.pathname + loc.search; // Last ditch effort to remove hash
        history.pushState("", document.title, urlWithoutHash);
    } else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}

function resetFilters(urlParams){
    urlParams.designers = [''];
    urlParams.sizes = [''];
    urlParams.colors = [''];
    urlParams.prices = [''];
    urlParams.heels = [''];
    urlParams.featuredCodes = [''];
    urlParams.arrivalDate = '';
    urlParams.catFilter = '';
    urlParams.pageNum = 1;
}

function getFilterParams(urlParams){
    let newURL = 'sortBy=' + urlParams.sortBy;
    let i = 0;
    if (urlParams.designers && urlParams.designers[0]) {
        if (urlParams.designers.length === 1)
            newURL += '&' + $.param({designer: urlParams.designers[0]});
        else
            newURL += '&' + $.param({designer: urlParams.designers}, true);
    }

    if (urlParams.sizes && urlParams.sizes[0]) {
        newURL += '&' + $.param({size: urlParams.sizes}, true);
    }

    if (urlParams.colors && urlParams.colors[0]) {
        newURL += '&' + $.param({color: urlParams.colors}, true);
    }

    if (urlParams.prices && urlParams.prices[0]) {
        newURL += '&' + $.param({price: urlParams.prices}, true);
    }

    if (urlParams.heels && urlParams.heels[0]) {
        newURL += '&' + $.param({heel: urlParams.heels}, true);
    }

    if (urlParams.conditions && urlParams.conditions[0]) {
        newURL += '&' + $.param({condition: urlParams.conditions}, true);
    }

    if (urlParams.category && urlParams.category[0]) {
        newURL += '&' + $.param({category: urlParams.category}, true);
    }

    if (urlParams.featuredCodes) {
        for (i = 0; i < urlParams.featuredCodes.length; i++) {
            if (urlParams.featuredCodes[i] != '') {
                newURL = newURL + '&featuredCodes=' + encodeURIComponent(urlParams.featuredCodes[i]);
            }
        }
    }
    if (urlParams.catFilter) {
        newURL = newURL + '&catFilter=' + encodeURIComponent(urlParams.catFilter);
    }
    if(urlParams.department) {
        newURL = newURL + '&d=' + encodeURIComponent(urlParams.department);
    }

    newURL = newURL + '&pageNum=' + urlParams.pageNum;
    return newURL;
}

// Prepare the path string.
// If '?' is not followed by '&' then replace it with with '?&'
function prepareForSafeRemove(path) {
    return  path.replace(/\?(?!&)/, "?&");
}

// Remove all occurrences of param and its values
function safeRemoveParam(path, param) {
    return path.replace(new RegExp("[&]+" + param + "=[^&\\b]*", "g"), '');
}

// Cleanup the path.
// Replace '?&' with '?
function cleanUpAfterSafeRemove(path) {
    path = path.replace(/\?&+/, '?');
    return path.replace(new RegExp("&{2,}", "g"), '&');
}

function removeFilterParams(urlParams) {

    let resultPath = urlParams.path;

    resultPath = prepareForSafeRemove(resultPath);

    resultPath = safeRemoveParam(resultPath, "sortBy");
    resultPath = safeRemoveParam(resultPath, "designer");
    resultPath = safeRemoveParam(resultPath, "size");
    resultPath = safeRemoveParam(resultPath, "color");
    resultPath = safeRemoveParam(resultPath, "heel");
    resultPath = safeRemoveParam(resultPath, "price");
    resultPath = safeRemoveParam(resultPath, 'condition');
    resultPath = safeRemoveParam(resultPath, 'category');
    resultPath = safeRemoveParam(resultPath, "featuredCodes");
    resultPath = safeRemoveParam(resultPath, "catFilter");
    resultPath = safeRemoveParam(resultPath, "pageNum");
    resultPath = safeRemoveParam(resultPath, "d");
    resultPath = safeRemoveParam(resultPath, 'personalshop');

    resultPath = cleanUpAfterSafeRemove(resultPath);

    return resultPath;
}

function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    const urlparts = url.split('?');
    if (urlparts.length >= 2) {

        const encodedPrefix = encodeURIComponent(parameter)+'=';
        const unencodedPrefix = parameter + '=';
        const pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (let i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(encodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
            else if (pars[i].lastIndexOf(unencodedPrefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
}

// Safe concatenation of url and param strings with taking care of '?' and '&' characters
function safeConcat(url, paramString) {
    let result = '';

    // get rid of the leading '?' or '&' characters
    paramString = removeLeadingChars(paramString);

    let endsWithAmpOrQuestion = /[\?&]$/;

    if (url.indexOf('?') > -1) {
        if (url.match(endsWithAmpOrQuestion)) {
            result = url + paramString;
        } else {
            result = url + '&' + paramString;
        }
    } else {
        result = url + '?' + paramString;
    }

    return result;
}

// Remove the leading '?' or '&' characters
function removeLeadingChars(paramString) {
    // remove RegExp
    return paramString.replace(/^[?&]+/, '');
}

// Replace existing parameters in url with new values in parameterString
function replaceURLParameters(url, parameterString){
    if (!parameterString)
        return url;

    const parameters = parameterString.split('&');
    let rtn = url;
    let tmp = '';
    if (parameters) {
        for (let i = 0; i < parameters.length; i++) {
            const p = parameters[i];
            if (p) {
                let parameterPair = p.split('=');
                if (parameterPair && parameterPair.length === 2){
                    rtn = removeURLParameter(rtn, parameterPair[0]);
                }
                tmp = appendQuery(tmp, p);
            }
        }

        rtn = safeConcat(rtn, tmp);
    }
    return rtn;
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/manage-refine-menu.js